import { Selector } from 'react-redux';
import { RootState } from '../../redux/root-reducer';
import { createSelector } from 'reselect';
import { IEvent } from '../../types/global/helper';
import { IEventFilter, IEventInitialState } from '../../redux/events/types';

export const eventsInitialStateSelector: Selector<RootState, IEventInitialState> = createSelector(
    (state: RootState) => state.events,
    events => events,
);

export const selectedEventDetailsSelector: Selector<RootState, IEvent | undefined> = createSelector(
    [eventsInitialStateSelector],
    event => event.selectedEvent,
);

export const similarEventsSelector: Selector<RootState, IEvent[]> = createSelector(
    [eventsInitialStateSelector],
    state => state.similarEvents,
);

export const loadingEventsSelector: Selector<RootState, boolean | undefined> = createSelector(
    [eventsInitialStateSelector],
    state => state.fetchingEvent,
);

export const allEventsSelector: Selector<RootState, IEvent[]> = createSelector(
    [eventsInitialStateSelector],
    state => state.events,
);

export const loadingEventSelector: Selector<RootState, boolean | undefined> = createSelector(
    [eventsInitialStateSelector],
    state => state.fetchingEvent,
);

export const selectedFiltersSelectors: Selector<RootState, IEventFilter | undefined> = createSelector(
    [eventsInitialStateSelector],
    state => state.eventsFilter,
);
